import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../reportId'
import * as lb from '../reportLables'
import { Box } from '@mui/system'
import DropDownOA from '../../../common/dropDownOA'
import { Checkbox, FormControlLabel } from '@mui/material'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import Datepicker from '../../../common/datePicker'
import { appendToUrl, diffInMonths, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import { RefreshSvg } from '../../../common/svg/refresh'
import { SplitButton } from '../../../common/SplitButton'
import { reportViewData } from '../analysisReport/constants'
import {
  reportOptionSum,
  bookingTypes,
  receiveTypes,
  reportOptionDet,
  updatePayTypeData,
  updateSummaryData,
  updateDetailData,
  paymentWiseColumns,
  SummaryColumns,
  ownReceiveUpdatedColumn,
  updateDetailData1,
} from './constants'
import { GetRequest } from '../../../common/api'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { getReceivedDropData } from '../../../../store/reports/reports_action'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import * as urlValue from '../oldReportsUrls'
import ManageColumns from "../../../common/ManageColumnsUI"
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../common/jotaiState/reportStateAtom'
import { useAtom, useSetAtom } from 'jotai'
import { RAJESH_TRANSPORT } from '../../../../helper/companyIdhardcode'
import { urls } from '../../../common/constants'

const ReceiveReportNew = () => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state)
  const companySetting = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySetting?.DefaultCurrencyID;
  const { common, reports } = state
  const { loginData, loader, roleRights, showModal, modalType, companySettings } = common
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD
  const { receivedDropData } = reports
  const allowFormatLR = companySettings?.[0]?.UseFormattedLRinReports
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selSourceCity, setSelSourceCity] = useState("")
  const [sourceCityData, setSourceCityData] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState("")
  const [sourceBranchData, setSourceBranchData] = useState([])
  const [selReceivedCity, setSelReceivedCity] = useState("")
  const [receivedCityData, setReceivedCityData] = useState([])
  const [selReceivedBranch, setSelReceivedBranch] = useState("")
  const [receivedBranchData, setreceivedBranchData] = useState([])
  const [bookingType, setBookingType] = useState(bookingTypes?.[0])
  const [receivedType, setReceivedType] = useState(receiveTypes?.[0])
  const [receiveTypeDis, setReceiveTypeDis] = useState(true)
  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const [reportOptions, setReportOptions] = useState(reportOptionDet?.[0])
  const [reportOptionsData, setReportOptionsData] = useState(reportOptionDet)
  const [showOnlyAutoRec, checkShowOnlyAutoRec] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [, setAlert] = useAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)

  const reportName = 'Receive'
  const manageColumns = { id: 'ReceivedManageColumns', lrListLabel: 'Manage Columns popup modal', isSaved: false }
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const [selCompany, setSelCompany] = useState(false)
  const { AllowGroupofCompanies = 0 } = roleRights?.Table1?.[0] || {}
  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany =
        ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) ||
        ChildCompanyList[0];
      setSelCompany(defaultCompany);
    } else {
      setSelCompany({
        CompanyID: loginData.intCompanyID,
        CompanyName: loginData.strCompanyName
      });
    }
  }, [ChildCompanyList, AllowGroupofCompanies]);
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intCompanyID: loginData?.intCompanyID,
        UserID: loginData?.intUserID
      }
      fetchChildCompanyList(body)
    }
  }, [loginData])
  const selectedCompanyName = selCompany?.CompanyName || loginData?.strCompanyName || ''
  const criteriaHeaders = [
    // { field: 'selectedCompany', header: 'Selected Company', textAlign: 'left' },
    { field: 'fromDate', header: 'From Receive Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Receive Date', textAlign: 'left' },
    { field: 'selSourceCity', header: 'Source City', textAlign: 'left' },
    { field: 'selSourceBranch', header: 'Source Branch', textAlign: 'left' },
    { field: 'selReceivedCity', header: 'Receive City', textAlign: 'left' },
    { field: 'selReceivedBranch', header: 'Receive Branch', textAlign: 'left' },
    { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'bookingType', header: 'Booking Type', textAlign: 'left' },
    { field: 'receiveType', header: 'Received Type', textAlign: 'left' },
    { field: 'reportView', header: 'Report View', textAlign: 'left' },
    { field: 'reportOptions', header: 'Report Options', textAlign: 'left' },
    { field: 'showOnlyAutoRec', header: 'Auto Received Only', textAlign: 'left' },
  ]
  const criteriaData = {
    // selectedCompany: selectedCompanyName,
    fromDate: moment(fromDate).format('DD-MM-YYYY') || '',
    toDate: moment(toDate).format('DD-MM-YYYY') || '',
    selSourceCity: selSourceCity?.SourceCity || '',
    selSourceBranch: selSourceBranch?.SourceBranch || '',
    selReceivedCity: selReceivedCity?.ToCity || '',
    selReceivedBranch: selReceivedBranch?.ToBranch || '',
    paymentType: paymentType?.name || '',
    bookingType: bookingType?.Type || '',
    receiveType: receivedType?.Type || '',
    reportView: reportView?.view || '',
    reportOptions: reportOptions?.Option || '',
    showOnlyAutoRec: showOnlyAutoRec ? 'Yes' : 'No',
    dataType: 'entry',
  }
  const headerData = {
    company: loginData.strCompanyName,
    toDate: moment(toDate).format("DD-MMM-YYYY"),
    fromDate: moment(fromDate).format("DD-MMM-YYYY"),
    selSourceCity: selSourceCity?.SourceCity,
    selSourceBranch: selSourceBranch?.SourceBranch,
    selReceivedCity: selReceivedCity?.ToCity || "",
    selReceivedBranch: selReceivedBranch?.ToBranch || "",
    paymentType: paymentType?.name,
    bookingType: bookingType?.Type,
    receiveType: receivedType?.Type,
    reportView: reportView?.view,
    reportOptions: reportOptions?.Option,
    showOnlyAutoRec: showOnlyAutoRec ? "Yes" : "No",
    criteriaHeaders,
    criteriaData: [criteriaData]
  }
  useEffect(() => {
    let updatedOptions = paymentModesWithAll.map(item => ({ ...item }));
    if (UseToPayAsCOD === 1) {
      updatedOptions = updatedOptions.map(item => {
        if (item.typeId === 2) return { ...item, name: 'COD' };
        if (item.typeId === 7) return { ...item, name: 'COD(MANUAL)' };
        if (item.typeId === 9) return { ...item, name: 'COD(DDDV)' };
        return item;
      });
      updatedOptions = updatedOptions.filter(item => item.typeId !== 4);
    }
    setPaymentOptions(updatedOptions);
  }, [UseToPayAsCOD]);
  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
      setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!isEmpty(receivedDropData)) {
      if (receivedDropData?.Data?.Table?.length > 0) {
        let data = []
        let data1 = []
        let data2 = []
        let data3 = []
        receivedDropData?.Data?.Table?.map((val, i) => {
          data.push({ SourceCity: val?.SourceCity, SourceCityID: val?.SourceCityID })
          data1.push({ SourceBranch: val?.SourceBranch, SourceBranchID: val?.SourceBranchID, SourceCity: val?.SourceCity })
          data2.push({ ToCity: val?.ToCity, ToCityID: val?.ToCityID, SourceCity: val.SourceCity })
          data3.push({ ToBranch: val?.ToBranch, ToBranchID: val?.ToBranchID, ToCity: val?.ToCity })
        })
        setSourceCityData([{ SourceCity: "All Cities", SourceCityID: 0 }, ...data])
        setSourceBranchData([{ SourceBranch: "All Branches", SourceBranchID: 0 }, ...data1])
        setReceivedCityData([...data2])
        setreceivedBranchData([...data3])
        const isCity = data2.filter(obj => obj.ToCityID === loginData?.intBranchCityID ? obj : "");
        const isBranch = data3.filter(obj => obj.ToBranchID === loginData?.intBranchID ? obj : "");
        setSelSourceCity({ SourceCity: "All Cities", SourceCityID: 0 })
        setSelSourceBranch({ SourceBranch: "All Branches", SourceBranchID: 0 })
        if (disableBtn) {
          setSelReceivedCity({ ToCity: loginData?.strCityName, ToCityID: loginData?.intBranchCityID })
          setSelReceivedBranch({ ToBranch: loginData?.strBranchName, ToBranchID: loginData?.intBranchID })
        } else {
          if (isCity?.length > 0) {
            setSelReceivedCity(isCity?.[0])
          } else {
            setSelReceivedCity(data2?.[0])
          }
          if (isBranch?.length > 0) {
            setSelReceivedBranch(isBranch?.[0])
          } else {
            setSelReceivedBranch(data3?.[0])
          }
        }
      } else {
        setSourceCityData([])
        setSourceBranchData([])
        setReceivedCityData([])
        setreceivedBranchData([])
        setSelSourceCity(" ")
        setSelSourceBranch(" ")
        setSelReceivedCity(" ")
        setSelReceivedBranch(" ")
      }
    }
  }, [receivedDropData])
  //   useEffect(() => {
  //     if (!isEmpty(receivedTableData)) {
  //       const arr1 = receivedTableData?.Data?.Table2?.map((item, i) => ({ ...item, SN: i + 1 })) || []
  //       const arr2 = receivedTableData?.Data?.Table3?.map((item, i) => ({ ...item, SN: i + 1 })) || []
  //       const updatedPayTypeData = updatePayTypeData(arr1, arr2, selSourceCity, selReceivedCity,UseToPayAsCOD,loginCountryId)
  //       setTableData({ ...tableData, payTypeTableData: updatedPayTypeData, detailTableData: receivedTableData?.Data?.Table, summaryTableData: receivedTableData?.Data?.Table1 })
  //     } else {
  //       setTableData({ payTypeTableData: [], detailTableData: [], summaryTableData: [] })
  //     }
  //   }, [receivedTableData])
  const uppdatedCol = ownReceiveUpdatedColumn(allowFormatLR, loginCountryId, UseToPayAsCOD)
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }
    const updateColumnDetails = async () => {
      try {
        const localUppdatedCol = await getLocalData('uppdatedCol');
        let filnalcol = localUppdatedCol || uppdatedCol
        if (RAJESH_TRANSPORT === loginData?.intCompanyID) {
          filnalcol = filnalcol.filter(
            (col) =>
              !["SenderName^^SenderMobileNo^^SenderGSTN^^SenderEmailID", "RecName^^RecMobileNo^^ReceiverGSTN^^ReceiverEmailID"].includes(col.field)
          )
        }
        // if(DeliveryReportPortrait ===1){
        //   filnalcol = filnalcol.filter((item)=>item.isMandatory)
        // }
        setManageColumn(filnalcol)
      } catch (error) {
        setManageColumn(uppdatedCol);
        console.error(error);
      }
    };
    updateColumnDetails()
  }, [])
  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem('uppdatedCol', JSON.stringify(item))
  }

  const selectedReportView = (value) => {
    setReportView(value)
    setShowTable(false)
    if (value?.id === 1) {
      setReportOptionsData(reportOptionSum)
      setReportOptions(reportOptionSum?.[0])
      setReceiveTypeDis(false)
    } else {
      setReportOptionsData(reportOptionDet)
      setReportOptions(reportOptionDet?.[0])
      setReceiveTypeDis(true)
      setReceivedType(receiveTypes?.[0])
    }
  }
  const processTableData = (receivedTableData) => {
    if (!isEmpty(receivedTableData)) {
      const arr1 = receivedTableData?.Data?.Table2?.map((item, i) => ({ ...item, SN: i + 1 })) || []
      const arr2 = receivedTableData?.Data?.Table3?.map((item, i) => ({ ...item, SN: i + 1 })) || []
      const updatedPayTypeData = updatePayTypeData(arr1, arr2, selSourceCity, selReceivedCity, UseToPayAsCOD, loginCountryId)
      return { payTypeTableData: updatedPayTypeData, detailTableData: receivedTableData?.Data?.Table, summaryTableData: receivedTableData?.Data?.Table1 }
    } else {
      return { payTypeTableData: [], detailTableData: [], summaryTableData: [] }
    }
  }

  const getMainHeader = (columns = []) =>
    columns.map((column) => {
      const header = column.header || column.headerName || column.exportHead || ''
      return {
        ...column,
        header,
        exportHead: column.exportHead || header,
        align: column.align || column.textAlign || column.headerSx?.textAlign || 'left',
        weight: column.weight ?? 80,
      }
    })

  const getPaymentTypeSourceHeaders = () =>
    getMainHeader(
      paymentWiseColumns
        .filter((column) => loginCountryId !== 2 || column.field !== 'ServiceTaxAmount')
        .map((column) =>
          column.field === 'Valuation' && loginCountryId === 2
            ? { ...column, headerName: 'Insurance Charge', exportHead: 'Insurance Charge' }
            : column
        )
    )

  const getSummaryHeaders = () =>
    getMainHeader(
      SummaryColumns
        .filter((column) => loginCountryId !== 2 || column.field !== 'ServiceTaxAmount')
        .map((column) => {
          if (column.field === 'Valuation' && loginCountryId === 2) {
            return { ...column, headerName: 'Insu.\nChrg', exportHead: 'Insu.\nChrg' }
          }
          if (column.field === 'ToPayCod' && UseToPayAsCOD === 1) {
            return { ...column, headerName: 'COD Amt.', exportHead: 'COD Amt.' }
          }
          return column
        })
    )

  const getDetailedHeaders = () => getMainHeader(manageColumn.length ? manageColumn : uppdatedCol)

  const openViewReport = (reportPayload) => {
    const rid = Date.now().toString()

    if (!window.generatedReports) {
      window.generatedReports = {}
    }

    window.generatedReports[rid] = reportPayload
    window.open(`/view-report?rid=${rid}`, '_blank')
  }

  const reportRedirect = (reportData) => {
    
    if (reportView?.id === 1) {
      if (reportOptions?.optionId === 1) {
        return {
          reportName: 'Receive Report (Pay Type and Source)',
          criteriaHeaders,
          criteriaData: [criteriaData],
          tableData: reportData?.payTypeTableData || [],
          mainHeader: getPaymentTypeSourceHeaders(),
          hideHeader: true,
          serialNokey :'SN',
          showColumnBorders: true,
          totalSubKey:3,
        }
      }

      return {
        reportName: reportOptions?.optionId === 3 ? 'Receive Report (Branch Summary)' : 'Receive Report (Only Summary)',
        criteriaHeaders,
        criteriaData: [criteriaData],
        tableData:
          updateSummaryData(reportData?.summaryTableData || [], headerData, UseToPayAsCOD, loginCountryId),
        mainHeader: getSummaryHeaders(),
        showColumnBorders: true,
        // hideHeader: true,
      }
    }

    return {
      reportName: 'Receive Report (Detailed)',
      criteriaHeaders,
      criteriaData: [criteriaData],
      tableData: updateDetailData1(reportData?.detailTableData || [], headerData, getDetailedHeaders()),
      mainHeader: getDetailedHeaders(),
      // hideHeader: true,
      isShowManageColumn: true,
      manageColumnID: 'uppdatedCol',
      colSpanMarker: 'ItemType',
      totalSubKey:3,
      serialNokey :'SN',
      showColumnBorders: true,
    }
  }

  const handleClick1 = async () => {
    if (selReceivedCity == "" || selReceivedCity == ' ') {
      dispatch(updateAlertError({ show: true, msg: 'Select Receive City', nextId: '' }))
    } else if (selReceivedBranch == "" || selReceivedBranch == ' ') {
      dispatch(updateAlertError({ show: true, msg: 'Select Receive Branch', nextId: '' }))
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
    } else if (receivedDropData?.Data?.Table?.length > 0) {
      const body = {
        CompanyID: selCompany?.CompanyID,
        FromDate: moment(fromDate).format("YYYY-MM-DD"),
        ToDate: moment(toDate).format("YYYY-MM-DD"),
        BookedCityID: selSourceCity?.SourceCityID,
        BookedBranchID: selSourceBranch?.SourceBranchID,
        ReceivedCityID: selReceivedCity?.ToCityID,
        ReceivedBranchID: selReceivedBranch?.ToBranchID,
        paymentTypeIDs: `${paymentType?.typeId}`,
        BookingMode: bookingType?.typeId,
        IsOnlyDestReceive: receivedType?.typeId,
        IsAutoReceiveReport: showOnlyAutoRec ? 1 : 0,
        UserID: loginData?.intUserID,
      }
      setLoader(true)
      try {
        const res = await GetRequest(urls.getReceivedTableData, body)
        setLoader(false)

        if (res?.status === 'Success') {
          const updatedData = {
            ...res,
            Data: {
              ...res.Data,
              Table: (res.Data.Table || []).map((item) => ({
                ...item,
                dataType: 'entry',
                PaymentType:
                  UseToPayAsCOD === 1 && item.PaymentTypeInt === 2
                    ? 'COD'
                    : item.PaymentTypeInt === 7
                      ? 'COD(MANUAL)'
                      : item.PaymentType,
              })),
              Table2: (res.Data.Table2 || []).map((item) => ({
                ...item,
                dataType: 'entry',
                PaymentType:
                  UseToPayAsCOD === 1 && item.PaymentTypeID === 2
                    ? 'COD'
                    : item.PaymentTypeID === 7
                      ? 'COD(MANUAL)'
                      : item.PaymentType,
              })),
              Table3: (res.Data.Table3 || []).map((item) => ({
                ...item,
                dataType: 'entry',
              })),
            },
          }
          const reportData = processTableData(updatedData)
          const reportPayload = reportRedirect(reportData)
          openViewReport(reportPayload)
        } else {
          setAlert({ show: true, msg: 'No Data', nextId: '' })
        }
      } catch (error) {
        setLoader(false)
      }
    } else {
      setAlert({ show: true, msg: 'No Data Found For Selected Date Range', nextId: '' })
      // dispatch(updateAlertError({ show: true, msg: 'No Data Found For Selected Date Range', nextId: '' }))
    }
  }
  const handleClick2 = () => {
    if (reportOptions?.optionId === 1 && reportView?.id === 1) {
      dispatch(updateAlertError({ show: true, msg: 'This Report Not Available in Old Formate', nextId: '' }))
    } else {
      let url = urlValue.receiveReport
      const urlData = urlValue.receiveReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.BranchId = selReceivedBranch?.ToBranchID || 0
      urlData.CompanyId = loginData.intCompanyID
      urlData.DateFrom = fromDate.format('DD-MMM-YYYY')
      urlData.DateTo = toDate.format('DD-MMM-YYYY')
      urlData.PaymentTypeId = paymentType?.typeId || 0
      urlData.BookingMode = bookingType?.typeId
      urlData.PaymentType = paymentType?.name === "All" ? `--All--` : paymentType?.name
      urlData.Bookingtype = bookingType?.Type
      urlData.BranchName = selReceivedBranch?.ToBranch
      urlData.BookedCityId = selSourceCity?.SourceCityID || 0
      urlData.BookedCityName = selSourceCity?.SourceCityID === 0 ? "--All--" : selSourceCity?.SourceCity
      urlData.IsAutoReceiveReport = showOnlyAutoRec ? 1 : 0
      urlData.IsSummaryReport = reportView?.id === 1 ? 1 : 0
      urlData.IsBranchSummaryReport = reportOptions?.optionId === 3 ? 1 : 0
      urlData.IsOnlyDestinationReceive = receivedType?.typeId === 1 ? 1 : 0
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }

  const filterData = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
    } else {
      const obj = {
        CompanyID: selCompany?.CompanyID,
        BranchID: disableBtn ? loginData?.intBranchID : 0,
        FromDate: moment(fromDate).format("YYYY-MM-DD"),
        ToDate: moment(toDate).format("YYYY-MM-DD")
      }
      dispatch(getReceivedDropData(obj))
    }
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    if (selReceivedCity == "" || selReceivedCity == " ") {
      setSelSourceCity("")
      setSelSourceBranch("")
      setSelReceivedCity('')
      setSelReceivedBranch('')
    } else {
      setSelSourceCity({ SourceCity: "All Cities", SourceCityID: 0 })
      setSelSourceBranch({ SourceBranch: "All Branches", SourceBranchID: 0 })
      setSelReceivedCity(' ')
      setSelReceivedBranch(' ')
    }
    setPaymentType(paymentOptions?.[0])
    setBookingType(bookingTypes?.[0])
    setReceivedType(receiveTypes?.[0])
    setReportView(reportViewData?.[0])
    setReportOptions(reportOptionDet?.[0])
    setReportOptionsData(reportOptionDet)
    setShowTable(false)
    checkShowOnlyAutoRec(false)
    setReceiveTypeDis(true)
  }
  const selectedSourceCity = (obj) => {
    setSelSourceCity(obj)
    setShowTable(false)
    setSelSourceBranch(removeDuplicatesFromArray(sourceBranchData, "SourceBranchID").filter((val) => val.SourceCity === obj?.SourceCity || obj?.SourceCityID === 0 || val.SourceBranchID === 0)?.[0])
  }
  const selectedRcvdCity = (obj) => {
    setSelReceivedCity(obj);
    setShowTable(false)
    setSelReceivedBranch(removeDuplicatesFromArray(receivedBranchData, "ToBranchID").filter((val) => val.ToCity === obj?.ToCity || obj?.ToCityID === 0 || val.ToBranchID === 0)?.[0])
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id="selectCompnay"
              prevId={'generateDiv'}
              nextId={'ArrowForwardIosIcon1'}
              label="Selected Company"
              data={ChildCompanyList}
              defaultvalue={selCompany?.CompanyName}
              disabled={AllowGroupofCompanies === 1 ? false : true}
              onSelect={(val) => setSelCompany(val)}
              dataKey={`CompanyName`}
              idKey={`CompanyID`}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: "120px" }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={"From Receive Date"}
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt(id.toDate)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: "120px" }} className="input--container bookingDatePicker">
            <Datepicker
              label={"To Receive Date"}
              value={toDate}
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt("ArrowForwardIosIcon2")
              }}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon2"
            sx={sx.itemsx}
            className="enable-wrapper"
            variant="contained"
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '4%',
              color: 'white',
              backgroundColor: '#fe5200',
              borderRadius: '4px',
              fontSize: 'large'
            }}
            onClick={() => filterData()}
            onKeyDown={(e) => navigation3(e, id.recvdSourceCity, id.toDate, () => filterData())}
          >
            GO
          </Item>
          <Item sx={sx.itemsx} style={{ width: "180px" }}>
            <DropDownOA
              id={id.recvdSourceCity}
              label={'Source City'}
              searchPlaceholder={`Search Source City`}
              defaultvalue={selSourceCity?.SourceCity || selSourceCity}
              data={removeDuplicatesFromArray(sourceCityData, "SourceCityID") || []}
              dataKey={`SourceCity`}
              idKey={`SourceCityID`}
              // onSelect={(obj) => { setSelSourceCity(obj); setShowTable(false) }}
              onSelect={(obj) => selectedSourceCity(obj)}
              nextId={id.recvdSourceBranch}
              prevId={"ArrowForwardIosIcon2"}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: "180px" }}>
            <DropDownOA
              id={id.recvdSourceBranch}
              label={'Source Branch'}
              searchPlaceholder={`Search Source Branch`}
              defaultvalue={selSourceBranch?.SourceBranch || selSourceBranch}
              data={removeDuplicatesFromArray(sourceBranchData, "SourceBranchID").filter((val) => val.SourceCity === selSourceCity?.SourceCity || selSourceCity?.SourceCityID === 0 || val.SourceBranchID === 0) || []}
              dataKey={`SourceBranch`}
              idKey={`SourceBranchID`}
              listWidth="250px"
              onSelect={(obj) => { setSelSourceBranch(obj); setShowTable(false) }}
              nextId={id.recvdReceivedCity}
              prevId={id.recvdSourceCity}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: "180px" }}>
            <DropDownOA
              id={id.recvdReceivedCity}
              label={'Receive City'}
              searchPlaceholder={`Search Receive City`}
              defaultvalue={selReceivedCity?.ToCity || selReceivedCity}
              data={removeDuplicatesFromArray(receivedCityData, "ToCityID").filter((val) => val.ToCity !== selSourceCity?.SourceCity || val.ToCity === 0) || []}
              dataKey={`ToCity`}
              idKey={`ToCityID`}
              disabled={disableBtn}
              // onSelect={(obj) => { setSelReceivedCity(obj); setShowTable(false) }}
              onSelect={(obj) => selectedRcvdCity(obj)}
              nextId={id.recvdReceivedBranch}
              prevId={id.recvdSourceBranch}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: "180px" }}>
            <DropDownOA
              id={id.recvdReceivedBranch}
              label={'Receive Branch'}
              searchPlaceholder={`Search Receive Branch`}
              defaultvalue={selReceivedBranch?.ToBranch || selReceivedBranch}
              data={removeDuplicatesFromArray(receivedBranchData, "ToBranchID").filter((val) => val.ToCity === selReceivedCity?.ToCity || selReceivedCity?.ToCityID === 0 || val.ToBranchID === 0) || []}
              dataKey={`ToBranch`}
              idKey={`ToBranchID`}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
              listWidth="202px"
              onSelect={(obj) => { setSelReceivedBranch(obj); setShowTable(false) }}
              nextId={id.recvdPaymentType}
              prevId={id.recvdReceivedCity}
            />
          </Item>
        </Box>
        <Box sx={{ ...sx.reportFlex, }}>
          <Item sx={sx.itemsx} style={{ width: "205px" }}>
            <DropDownOA
              id={id.recvdPaymentType}
              data={paymentOptions || []}
              defaultvalue={paymentType?.name}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`typeId`}
              onSelect={(value) => { setPaymentType(value); setShowTable(false) }}
              nextId={id.recvdBookingType}
              prevId={id.recvdReceivedBranch}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: "180px" }}>
            <DropDownOA
              id={id.recvdBookingType}
              defaultvalue={bookingType?.Type || ""}
              data={bookingTypes}
              width="100%"
              searchPlaceholder={`Search Booking Type`}
              label={'Booking Type'}
              tabIndex="2"
              dataKey={`Type`}
              idKey={`typeId`}
              onSelect={(value) => { setBookingType(value); setShowTable(false) }}
              nextId={id.recvdReceivedType}
              prevId={id.recvdPaymentType}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: "175px" }}>
            <DropDownOA
              id={id.recvdReceivedType}
              defaultvalue={receivedType?.Type || ""}
              data={receiveTypes}
              disabled={receiveTypeDis}
              width="100%"
              searchPlaceholder={`Search Received Type`}
              label={'Received Type'}
              tabIndex="2"
              dataKey={`Type`}
              idKey={`typeId`}
              onSelect={(value) => { setReceivedType(value); setShowTable(false) }}
              nextId={id.recvdView}
              prevId={id.recvdBookingType}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: "147px" }}>
            <DropDownOA
              id={id.recvdView}
              defaultvalue={reportView?.view}
              data={reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => selectedReportView(value)}
              nextId={id.recvdReportOptions}
              prevId={id.recvdReceivedType}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: "190px" }}>
            <DropDownOA
              id={id.recvdReportOptions}
              data={reportOptionsData || []}
              defaultvalue={reportOptions?.Option || ""}
              width="100%"
              searchPlaceholder={`Search By Report Options`}
              label={'Report Options'}
              tabIndex="2"
              dataKey={`Option`}
              idKey={`optionId`}
              listWidth="200px"
              onSelect={(value) => { setReportOptions(value); setShowTable(false) }}
              nextId={id.showOnlyAutoRec}
              prevId={id.recvdView}
            />
          </Item>
          <FormControlLabel
            value="end"
            control={<Checkbox />}
            id={id.showOnlyAutoRec}
            label="Auto Received Only"
            labelPlacement="end"
            checked={showOnlyAutoRec}
            onChange={() => {
              checkShowOnlyAutoRec(!showOnlyAutoRec)
              focusElemnt(id.reportmainButton)
              setShowTable(false)
            }}
            onKeyDown={(e) => navigation3(e, id.reportmainButton, id.recvdReportOptions, () => {
              checkShowOnlyAutoRec(!showOnlyAutoRec)
              focusElemnt(id.reportmainButton)
              setShowTable(false)
            })}
          />
          <Item sx={sx.itemsx} style={{ cursor: "pointer" }} onKeyDown={(e) => navigation3(e, showTable ? disableExcel ? "ExportToPdf" : "ExportToExl" : id.fromDate, id.showOnlyAutoRec, () => handleClick1())}>
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              id1={id.reportmainButton}
              prevID={id.summaryCheck}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: "pointer" }} onClick={() => reset()} >
            <RefreshSvg width={"24px"} height={"24px"} />
          </Item>
        </Box>
      </Item>
      <Item>
        {/* {(showTable && !loader) && tableShow()} */}
      </Item>
      {showModal && manageColumns.id === modalType ? <ManageColumns headers={manageColumn || []} onSave={onSaveColumns} updateModal={() => { dispatch(updateModal(false, "")) }} /> : null}
      {/* {showModal && manageColumns.id === modalType ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} /> : null} */}

    </>
  )
}

export default ReceiveReportNew
